/**
 * ZUS Leathers - Product Page JavaScript
 */

(function() {
  'use strict';

  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  // Media gallery
  const mainImg = qs('[data-product-main-image]');
  const thumbs = qsa('[data-product-thumb]');

  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src || thumb.querySelector('img')?.src;
        if (src) {
          mainImg.src = src.replace(/(\.[^.]+)$/, '_1200x$1').replace('_1200x_1200x', '_1200x');
          // Better: use data-full
          if (thumb.dataset.full) mainImg.src = thumb.dataset.full;
        }
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // Variant selection
  const productForm = qs('[data-product-form]');
  const variantInput = qs('[name="id"]', productForm);
  const priceEl = qs('[data-product-price]');
  const compareEl = qs('[data-product-compare]');
  const addBtn = qs('[data-add-to-cart]', productForm);
  const stickyAtc = qs('.sticky-atc');

  // Parse product JSON
  let productData = null;
  const productJson = qs('[data-product-json]');
  if (productJson) {
    try { productData = JSON.parse(productJson.textContent); } catch {}
  }

  function updateVariant() {
    if (!productData) return;

    const selected = {};
    qsa('[data-option-input]:checked, [data-option-select]').forEach(el => {
      const name = el.dataset.optionName || el.name;
      selected[name] = el.value;
    });

    // Also handle size/color buttons
    qsa('[data-option-value].is-selected').forEach(btn => {
      selected[btn.dataset.optionName] = btn.dataset.value;
    });

    const variant = productData.variants.find(v => {
      return v.options.every((opt, i) => {
        const optionName = productData.options[i];
        return !selected[optionName] || selected[optionName] === opt;
      });
    });

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = window.theme?.strings?.unavailable || 'Unavailable';
      }
      return;
    }

    if (variantInput) variantInput.value = variant.id;

    // Price
    if (priceEl) {
      const money = (cents) => '₹' + (cents / 100).toLocaleString('en-IN');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<span class="compare">${money(variant.compare_at_price)}</span><span class="sale">${money(variant.price)}</span>`;
      } else {
        priceEl.innerHTML = money(variant.price);
      }
    }

    // Availability
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = window.theme?.strings?.addToCart || 'Add to Bag';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = window.theme?.strings?.soldOut || 'Sold Out';
      }
    }

    // Update sticky
    if (stickyAtc) {
      const stickyPrice = qs('[data-sticky-price]', stickyAtc);
      if (stickyPrice) stickyPrice.innerHTML = priceEl ? priceEl.innerHTML : '';
    }

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  // Option buttons (swatches / sizes)
  qsa('[data-option-value]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-option-group]');
      if (group) {
        qsa('[data-option-value]', group).forEach(b => b.classList.remove('is-selected'));
      }
      btn.classList.add('is-selected');
      updateVariant();
    });
  });

  // Radio / select change
  qsa('[data-option-input], [data-option-select]').forEach(el => {
    el.addEventListener('change', updateVariant);
  });

  // Sticky ATC visibility
  if (stickyAtc && productForm) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(productForm);
  }

  // Sticky ATC button
  const stickyBtn = qs('[data-sticky-add]', stickyAtc);
  if (stickyBtn && addBtn) {
    stickyBtn.addEventListener('click', () => {
      addBtn.click();
    });
  }

  // Add recently viewed
  if (productData && window.ZUS) {
    window.ZUS.addRecentlyViewed({
      id: productData.id,
      title: productData.title,
      handle: productData.handle,
      price: productData.price,
      image: productData.featured_image,
      url: `/products/${productData.handle}`
    });
  }

  // Pincode checker (placeholder architecture)
  const pincodeForm = qs('[data-pincode-check]');
  if (pincodeForm) {
    pincodeForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = qs('[data-pincode-input]', pincodeForm);
      const result = qs('[data-pincode-result]', pincodeForm);
      if (!input || !input.value) return;
      // Architecture ready for logistics app integration
      if (result) {
        result.textContent = 'Delivery estimates available after connecting your shipping provider.';
        result.style.display = 'block';
      }
    });
  }

  // Init
  updateVariant();

})();
